import React, { useState } from "react";
import "./App.css";
import * as XLSX from "xlsx";
import _, { isEmpty } from "lodash";
import { CSVLink } from "react-csv";

function Study(props) {
  const [items, setItems] = useState([]);
  const [dataSent, setdataSent] = useState(false);
  const [csvDatas, setcsvData] = useState([]);

  const processThem = (dataFromFile) => {
    let group = _.chain(dataFromFile)
      .map((value, key) => {
        let dateArr = [];
        dateArr.push({
          date: _.keys(value),
          value: _.values(value),
        });
        return dateArr;
      })
      .flatMap()
      .map((value, key) => {
        let someArr = [];
        value.date.map((val, ind) => {
          someArr.push({ date: val, ind: ind });
        });
        value.value.map((val, ind) => {
          someArr.push({ ptid: val, ind: ind });
        });
        return someArr;
      })
      .map((value, key) => {
        return _.chain(value)
          .groupBy("ind")
          .map((grpA, grpind) => _.merge(grpA[0], grpA[1]))
          .value();
      })
      .flattenDeep()
      .groupBy("date")
      .map((dateA, dateind) => {
        let someAArr = [];
        someAArr.push({
          date: dateA[0].date,
          sampled: _.sampleSize(dateA, 10),
        });

        return someAArr;
      })
      .flattenDeep()
      .value();
    setItems(group);
  };

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[1];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws, { raw: false });

        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      processThem(d);
    });
  };
  React.useEffect(() => {
    // [{ set: "1", date: "6/1/21", sample: "1723" }]
    let csvData = [];

    items.map((item, index) => {
      item.sampled.map((sample, sampIndex) => {
        csvData.push({
          set: index + 1,
          date: sample.date,
          hospital_id: sample.ptid,
          site_code: props.site_code,
        });
      });
    });
    if (!isEmpty(csvData)) {
      setcsvData(csvData);
    }
  }, [items, props.site_code]);

  const saveData = () => {
    if (!dataSent) {
      let query = {
        query: `
     mutation ($objects: [imucor_insert_input!]!) {
        insert_imucor(objects: $objects) {
          affected_rows
        }
      }
    `,
        variables: { objects: csvDatas },
      };

      fetch("http://128.199.16.249/v1/graphql", {
        method: "POST",
        headers: { "x-hasura-admin-secret": "Remember001" },
        body: JSON.stringify(query),
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(`result`, result);
          setdataSent(true);
        })
        .catch((err) => console.error(`${err}`));
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "flex-end",
        }}
      >
        <div>
          <label for="formFileLg" className="form-label">
            Choose an <kbd>.xlsx</kbd> file to proceed
          </label>
          <input
            type="file"
            id="formFileLg"
            className="form-control form-control-lg"
            onChange={(e) => {
              const file = e.target.files[0];
              readExcel(file);
            }}
          />
        </div>
        <div
          style={{
            display: items.length > 0 ? "flex" : "none",
            marginLeft: 20,
          }}
        >
          <CSVLink
            data={csvDatas}
            filename={`I-MUCOR-NIE-${props.site_code}-${Date.now()}.csv`}
            className="btn btn-primary"
            onClick={() => {
              saveData();
              return;
            }}
          >
            Download result as CSV
          </CSVLink>
        </div>
      </div>
      {items?.length > 0 ? (
        <React.Fragment>
          <div className="card container mt-10">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col">Sample Size</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => {
                  return (
                    <>
                      <tr key={index}>
                        <th>{item?.date}</th>
                        <td>{item?.sampled?.length}</td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="card container mt-10">
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Set #</th>
                  <th scope="col">Date</th>
                  <th scope="col">Sample ID</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => {
                  return (
                    <>
                      {item.sampled.map((sample, sampIndex) => {
                        return (
                          <tr key={sampIndex}>
                            <th>{index + 1}</th>
                            <th>{sample.date}</th>
                            <td>{sample.ptid}</td>
                          </tr>
                        );
                      })}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
}

export default Study;
